<template>
  <edit-field ref="CRENEAU_HEURE_DEBUT"
              :value=value
              :contextId=contextId
              :editFieldInfo=editFieldInfo
              :hideLabel='hideLabel'
              :min=min
              :max=max
              :required=required
              :disabled=readOnly
              @updated=setUpdated
              @context=setInitValue
              @error=setError>
  </edit-field>
</template>

<script lang="ts">
  import { defineComponent } from "vue";
  import EditBase from '@/framework/base/components/EditBase';
  import EditField from '@/framework/base/components/EditField.vue'
  import { EditFieldType, FieldInfo } from '@/framework/base/components/FieldInfo'
  import validator, { Rule, RULES_FRENCH_LABEL } from '@/generated/validators/ValidationRules';
  import { DateFormat } from '@/framework/base/helpers/DateFormat';
  import { RessourceGenControl, GenControl } from '@/generated/ressources/generatedRessources';

  export default defineComponent({
    extends: EditBase,
    components: {
      EditField
    },
    data() {
      const regEx = /^(\d{1,2})([:]{0,1})(\d{0,2})$/;
      return {
        regEx,
      }
    },
    computed: {
      ressource () { return RessourceGenControl(GenControl.CRENEAU_HEURE_DEBUT); },
      editFieldInfo (): FieldInfo {
        const type = EditFieldType.STRING;
        const precision = 2;
        const format = null;
        const mask = null;
        const focus = this.focusValidator;
        const live = this.liveValidator;
        return new FieldInfo(this.ressource, type, precision, mask, format, focus, live);
      }
    },
    methods: {
      // eslint-disable-next-line
      focusValidator (value: string): validator | null {
        const focusValidator: Rule = { function: this.updateSaisie, useMask: false };
        return new validator(focusValidator, RULES_FRENCH_LABEL.text.timeFormatValid.error);
      },

      // eslint-disable-next-line
      liveValidator (value: string): validator | null {
        const liveValidator: Rule = { function: this.checkSaisie, useMask: false };
        return new validator(liveValidator, RULES_FRENCH_LABEL.text.timeFormatValid.error);
      },

      updateSaisie (value: string): boolean {
        if (this.checkSaisie(value)) {
          const match = value.match(this.regEx);
          if (match) {
            this.setUpdated(DateFormat.getHeuresMinutes(value));
          }
          return true;
        } else {
          return false;
        }
      },

      checkSaisie (value: string): boolean {
        return this.regEx.test(value);
      },

      missing (): boolean {
        // @ts-expect-error : generated method
        return this.$refs.CRENEAU_HEURE_DEBUT.missing();
      },

      touch (): boolean {
        // @ts-expect-error : generated method
        return this.$refs.CRENEAU_HEURE_DEBUT.touch();
      },

      setFocus (): void {
        // @ts-expect-error : generated method
        this.$refs.CRENEAU_HEURE_DEBUT.setFocus();
      }
    }
  })
</script>
